import { Signal } from '@angular/core';
import { Result } from '../models/http-response.model';
import { RegisterUserDto } from '../dtos/auth.dto';
import { PublicUserModel, UserModel } from '../models/user-profile.dto';
import { ChangePasswordDto } from '../dtos/change-password.dto';
import { ResetPasswordDto } from '../dtos/reset-password.dto';
import { ServerError } from '../models/server-error';
import { UpdateUserDto } from '../dtos/update-user.dto';

export abstract class AuthRepositoryQuery {
  abstract isLoggedIn: Signal<boolean>;
  abstract userProfile: Signal<UserModel | null>;
}

export abstract class AuthRepository extends AuthRepositoryQuery {
  abstract login(
    email: string,
    password: string
  ): Promise<Result<{ token: string }, ServerError>>;
  abstract register(data: RegisterUserDto): Promise<Result<any, ServerError>>;
  abstract logout(): Promise<Result<any, any>>;
  abstract verifyEmail(code: string): Promise<Result<any, any>>;
  abstract verifyEmailResend(): Promise<Result<any, any>>;
  abstract getProfile(): Promise<Result<UserModel, Error>>;
  abstract getPublicUserProfile(
    userId: string
  ): Promise<Result<PublicUserModel, Error>>;
  abstract updateProfile(
    data: UpdateUserDto
  ): Promise<Result<{ user: UserModel }, ServerError>>;
  abstract deleteProfile(): Promise<Result<any, Error>>;
  abstract changePassword(
    data: ChangePasswordDto
  ): Promise<Result<undefined, ServerError>>;
  abstract forgotPassword(email: string): Promise<Result<undefined, Error>>;
  abstract resetPassword(
    resetPasswordData: ResetPasswordDto
  ): Promise<Result<undefined, Error>>;
  abstract updateProfileImage(
    profileImage: File
  ): Promise<Result<{ data: { profile_image_url: string } }, Error>>;
  abstract deleteProfileImage(): Promise<Result<undefined, Error>>;
}
